export default "__VITE_ASSET__BseuhErk__"